<section class="open-module-page">
    <div class="logo-background-container">
        <div class="logo"></div>
    </div>
    <section class="router-content">
        <router-outlet></router-outlet>
    </section>
</section>
